import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';
declare function ire(string,{}): any;
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('關於Trinka-學術和技術寫作的唯一工具');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka是學術和技術寫作的唯一工具。我們的目標是消除語言和寫作技能在有效知識溝通上形成的障礙。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '用於學術和技術寫作的文法檢查工具，學術寫作助手，技術寫作助手，高級文法檢查，自動文法檢查工具' });
    this.metaTagService.updateTag({ property: 'og:title', content: '關於Trinka-學術和技術寫作的唯一工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka是學術和技術寫作的唯一工具。我們的目標是消除語言和寫作技能在有效知識溝通上形成的障礙。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/aboutus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/aboutus' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }
  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/branding_logo.js', function () { });
    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
